module.exports = __webpack_public_path__ + "static/media/pfl-fighter-bg.06fd76a3.jpg";